import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { ProductECommerceConfig } from '../../../../generated/generated-types';
import { HotkeysService } from '../../../hotkeys/services/hotkeys.service';
import { TaxonomyCategoryDropDownComponent } from '../../controls/taxonomy-category-drop-down/taxonomy-category-drop-down.component';
import { ProductECommerceConfigService } from '../../services/product-e-commerce-config.service';

@Component({
  selector: 'app-product-ecommerce-widget',
  imports: [
    CommonModule,
    TabsModule,
    TaxonomyCategoryDropDownComponent,
    TranslatePipe,
  ],
  providers: [HotkeysService],
  templateUrl: './product-ecommerce-widget.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductECommerceWidgetComponent extends BaseDetailComponent<ProductECommerceConfig> {

  private productECommerceConfigService = inject(ProductECommerceConfigService);
  protected override crudService = this.productECommerceConfigService;


}
